import { Stack } from "expo-router";
import React from "react";

export default function MyMediaLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ title: "My Media" }} />
      <Stack.Screen name="[id]" options={{ title: "Media Details" }} />
    </Stack>
  );
}
